module.exports = __webpack_public_path__ + "fonts/Lato-BlackItalic.a8642cee.eot";